import type React from 'react';

function AirmeeIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 38.45 38.45"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Airmee Icon</title>

      <g id="Layer_1-2" data-name="Layer 1">
        <path
          d="M.68,9.59v8.11H14.56c-2.1,2.53-5.6,6.95-7.91,9.72-1.17,1.41-2.34,2.15-4.2,2.15H.68v8.2h1.69c5.28,0,7.49-1.19,12.54-7.47l5.34-6.64v14.11h7.91V9.59H.68Z"
          fill="inherit"
        />
        <path d="M37.71,.49h-9.55V9.59h9.55V.49Z" fill="inherit" />
        <rect width="38.45" height="38.45" fill="none" />
      </g>
    </svg>
  );
}

export default AirmeeIcon;
